import React, { useState } from "react";
import { Table, Typography, message } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { errorMessage } from "../../../helpers/errorMessageFunc";
import { backendPostReturnPromise } from "../../../helpers/callBackend";
import GenericOnClickModal from "../../buttons/genericOnClickModal";
import CsvUpload from "../../imports/csvUpload";
import LoadingButton from '@mui/lab/LoadingButton';


const { Title } = Typography;

const columns = [
    {
        title: "Date",
        dataIndex: "date",
        render(text, record) {
            return <span>{text?.slice(0, 10)}</span>;
        }
    },
    {
        title: "To/From",
        dataIndex: "counterpartyName",
    },
    {
        title: "Description",
        dataIndex: "description",
    },
    {
        title: "Amount",
        dataIndex: "amount",
    },
];

const requiredFields = [
    "date",
    "counterpartyName",
    "description",
    "amount",
];

const UploadTransactionsCsv = (props) => {
    const [csvData, setCsvData] = useState([]);
    const [loading, setLoading] = useState(false);


    const handleSubmit = () => {
        if (csvData.length === 0) {
            return errorMessage(
                "Csv File provided is blank. Please upload a valid csv file."
            );
        }

        let sampleRowFromCsv = csvData[0];
        let fieldsFromCsv = Object.keys(sampleRowFromCsv);

        const allFieldsArePresent = requiredFields.every((field) => {
            return fieldsFromCsv.includes(field);
        });

        if (!allFieldsArePresent) {
            return errorMessage(
                "Csv File doesn't contain all the required fields. Please upload a valid csv file.",
                10
            );
        }

        message.loading("Submitting request..", 5);
        setLoading(true);
        const promises = [];

        for (let i = 0; i < csvData.length; i++) {
            promises.push(
                backendPostReturnPromise("/api/transactions/manual/", {
                    ...csvData[i],
                    bankAccountId: props.bankAccountId,
                })
            );
        }

        Promise.all(promises)
            .then((results) => {
                setLoading(false);
                // window.location.reload(false);
                const newTransactions = results.map((result) => result.data)
                props.setTransactionsTable((prevState) => {
                    return [...prevState, ...newTransactions]
                })
                // There is something off with the serializer and the way transactionsTable data is updating state - need to investigate this
                // description on response should not be "transaction uploaded successfully"
                // the window reload needs to be removed, and then the modal needs to be closed when the state update is fixed
            })
            .catch((err) => {
                // Handle errors here
                console.error(err);
                errorMessage(err.message);
                setLoading(false);
            });
    };

    return (
        <GenericOnClickModal
            size="lg"
            button={
                <a>
                    Upload Transactions <ArrowRightOutlined />{" "}
                </a>
            }
            modalTitle={"Upload CSV file with the transactions data"}
            modalBody={
                <>
                    <div>
                        <Title level={5}>
                            Please make sure csv file contains all the below
                            mentioned fields!
                        </Title>

                        <ul
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                height: "170px",
                                flexDirection: "column",
                                gap: "6px",
                            }}
                        >
                            {requiredFields.map((field) => {
                                return <li key={field}>{field}</li>;
                            })}
                        </ul>
                    </div>

                    <CsvUpload setCsvData={setCsvData} />

                    {csvData.length > 0 && (
                        <div style={{ margin: "10px 0" }}>
                            <Title level={5}>
                                Are you sure to continue with the following
                                transactions ?{" "}
                            </Title>
                            <Table
                                pagination={{
                                    defaultPageSize: 5,
                                    showSizeChanger: true,
                                }}
                                columns={columns}
                                dataSource={csvData}
                                tableLayout="fixed"
                                size="small"
                            />

                            <LoadingButton
                                loading={loading}
                                onClick={handleSubmit}
                                loadingPosition="start" disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                                sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                            >
                                Submit
                            </LoadingButton>
                        </div>
                    )}
                </>
            }
        ></GenericOnClickModal>
    );
};

export default UploadTransactionsCsv;
